import React, { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

export default function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const role = localStorage.getItem('role') || 'user';
  const isAdmin = role === 'global_admin' || role === 'assessment_admin' || role === 'admin';

  const handleHamburgerClick = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleSidebarClose = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="min-h-screen bg-eucnet-grey-100">
      <Header onHamburgerClick={isAdmin ? handleHamburgerClick : undefined} />
      <div className="flex">
        {isAdmin && <Sidebar isOpen={sidebarOpen} onClose={handleSidebarClose} collapsed={sidebarCollapsed} onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)} />}
        <main className={`flex-1 overflow-auto ${isAdmin ? (sidebarCollapsed ? 'md:ml-20' : 'md:ml-64') : ''}`}>
          {children}
        </main>
      </div>
    </div>
  );
}
